import Dexie, { type Table } from 'dexie';

export interface LocalPlay {
  id: string;
  createdAt: string;
  sceneId: string;
  worldName: string;
  answer: number;
  userAnswer: number;
  countError: number;
  noticed: boolean;
  anomalyLabel: string;
  blindspotClass: string;
  submitted: boolean;
}

class PlainSightLocalDb extends Dexie {
  plays!: Table<LocalPlay, string>;

  constructor() {
    super('plain-sight-census');
    this.version(1).stores({
      plays: 'id, createdAt, sceneId, noticed, blindspotClass, submitted'
    });
  }
}

export const localDb = new PlainSightLocalDb();

export async function saveLocalPlay(play: LocalPlay): Promise<void> {
  await localDb.plays.put(play);
}

export async function recentLocalPlays(limit = 12): Promise<LocalPlay[]> {
  return localDb.plays.orderBy('createdAt').reverse().limit(limit).toArray();
}
